import { Device } from '../types/device';

export const mockDevices: Device[] = [
    {
        id: "550e8400-e29b-41d4-a716-446655440000",
        name: "Welding - M-500",
        type: "welding_device",
        status: "connected",
        lastSeen: "2024-03-20T10:30:00Z",
        connectedEquipment: {
          id: "eq-001",
          name: "Miller XMT 350",
          type: "welding_machine",
          model: "XMT-350-MPa",
          serialNumber: "WM2024001"
        },
        project: {
          id: "proj-001",
          name: "Pipeline Section North",
          status: "active",
          startDate: "2024-01-15"
        },
        metadata: {
          manufacturer: "CRC-Evans",
          model: "WS-2000",
          serialNumber: "WS2024A1",
          installationDate: "2024-01-15",
          firmware: "v2.1.0"
        }
      },
      {
        id: "550e8400-e29b-41d4-a716-446655440001",
        name: "Coating - IMPP",
        type: "coating_device",
        status: "commissioned",
        lastSeen: "2024-03-20T10:35:00Z",
        connectedEquipment: {
          id: "eq-002",
          name: "CRC-Evans Coating System",
          type: "coating_machine",
          model: "ACS-2000",
          serialNumber: "CM2024002"
        },
        project: {
          id: "proj-002",
          name: "Pipeline Section South",
          status: "active",
          startDate: "2024-02-01"
        },
        metadata: {
          manufacturer: "CRC-Evans",
          model: "CS-3000",
          serialNumber: "CS2024B2",
          installationDate: "2024-02-01",
          firmware: "v3.0.1"
        }
      },
      {
        id: "550e8400-e29b-41d4-a716-446655440002",
        name: "Welding - P-625",
        type: "welding_device",
        status: "communicating",
        lastSeen: "2024-03-20T10:40:00Z",
        connectedEquipment: {
          id: "eq-003",
          name: "Lincoln Electric Power Wave",
          type: "welding_machine",
          model: "PW-S500",
          serialNumber: "WM2024003"
        },
        project: {
          id: "proj-001",
          name: "Pipeline Section North",
          status: "active",
          startDate: "2024-01-15"
        },
        metadata: {
          manufacturer: "CRC-Evans",
          model: "WS-2000",
          serialNumber: "WS2024C3",
          installationDate: "2024-01-20",
          firmware: "v2.1.0"
        }
      },
      {
        id: "550e8400-e29b-41d4-a716-446655440003",
        name: "Coating Unit D4",
        type: "coating_device",
        status: "disconnected",
        lastSeen: "2024-03-19T15:30:00Z",
        connectedEquipment: {
          id: "eq-004",
          name: "CRC-Evans Coating System",
          type: "coating_machine",
          model: "ACS-2000",
          serialNumber: "CM2024004"
        },
        metadata: {
          manufacturer: "CRC-Evans",
          model: "CS-3000",
          serialNumber: "CS2024D4",
          installationDate: "2024-01-25",
          firmware: "v3.0.1"
        }
      },
      {
        id: "550e8400-e29b-41d4-a716-446655440004",
        name: "Welding Station E5",
        type: "welding_device",
        status: "decommissioned",
        lastSeen: "2024-02-20T10:30:00Z",
        metadata: {
          manufacturer: "CRC-Evans",
          model: "WS-2000",
          serialNumber: "WS2024E5",
          installationDate: "2023-08-15",
          firmware: "v2.0.0"
        }
      },
      {
        id: "550e8400-e29b-41d4-a716-446655440005",
        name: "Coating Unit F6",
        type: "coating_device",
        status: "connected",
        lastSeen: "2024-03-20T10:44:00Z",
        connectedEquipment: {
          id: "eq-006",
          name: "CRC-Evans Coating System",
          type: "coating_machine",
          model: "ACS-3000",
          serialNumber: "CM2024006"
        },
        project: {
          id: "proj-003",
          name: "Pipeline Section East",
          status: "active",
          startDate: "2024-02-15"
        },
        metadata: {
          manufacturer: "CRC-Evans",
          model: "CS-3000",
          serialNumber: "CS2024F6",
          installationDate: "2024-02-15",
          firmware: "v3.0.2"
        }
      },
      {
        id: "550e8400-e29b-41d4-a716-446655440006",
        name: "Welding Station G7",
        type: "welding_device",
        status: "communicating",
        lastSeen: "2024-03-20T10:43:00Z",
        connectedEquipment: {
          id: "eq-007",
          name: "Miller Dynasty",
          type: "welding_machine",
          model: "DY-280-DX",
          serialNumber: "WM2024007"
        },
        project: {
          id: "proj-002",
          name: "Pipeline Section South",
          status: "active",
          startDate: "2024-02-01"
        },
        metadata: {
          manufacturer: "CRC-Evans",
          model: "WS-2000",
          serialNumber: "WS2024G7",
          installationDate: "2024-02-01",
          firmware: "v2.1.1"
        }
      },
      {
        id: "550e8400-e29b-41d4-a716-446655440007",
        name: "Coating Unit H8",
        type: "coating_device",
        status: "commissioned",
        lastSeen: "2024-03-20T10:42:00Z",
        connectedEquipment: {
          id: "eq-008",
          name: "CRC-Evans Coating System",
          type: "coating_machine",
          model: "ACS-2000",
          serialNumber: "CM2024008"
        },
        project: {
          id: "proj-003",
          name: "Pipeline Section East",
          status: "active",
          startDate: "2024-02-15"
        },
        metadata: {
          manufacturer: "CRC-Evans",
          model: "CS-3000",
          serialNumber: "CS2024H8",
          installationDate: "2024-02-15",
          firmware: "v3.0.2"
        }
      },
      {
        id: "550e8400-e29b-41d4-a716-446655440008",
        name: "Welding Station I9",
        type: "welding_device",
        status: "disconnected",
        lastSeen: "2024-03-19T16:30:00Z",
        connectedEquipment: {
          id: "eq-009",
          name: "Lincoln Electric Power Wave",
          type: "welding_machine",
          model: "PW-S500",
          serialNumber: "WM2024009"
        },
        metadata: {
          manufacturer: "CRC-Evans",
          model: "WS-2000",
          serialNumber: "WS2024I9",
          installationDate: "2024-02-20",
          firmware: "v2.1.1"
        }
      },
      {
        id: "550e8400-e29b-41d4-a716-446655440009",
        name: "Coating Unit J10",
        type: "coating_device",
        status: "connected",
        lastSeen: "2024-03-20T10:41:00Z",
        connectedEquipment: {
          id: "eq-010",
          name: "CRC-Evans Coating System",
          type: "coating_machine",
          model: "ACS-3000",
          serialNumber: "CM2024010"
        },
        project: {
          id: "proj-001",
          name: "Pipeline Section North",
          status: "active",
          startDate: "2024-01-15"
        },
        metadata: {
          manufacturer: "CRC-Evans",
          model: "CS-3000",
          serialNumber: "CS2024J10",
          installationDate: "2024-01-25",
          firmware: "v3.0.2"
        }
      },
      {
        id: "550e8400-e29b-41d4-a716-446655440010",
        name: "Welding Station K11",
        type: "welding_device",
        status: "communicating",
        lastSeen: "2024-03-20T10:40:00Z",
        connectedEquipment: {
          id: "eq-011",
          name: "Miller XMT 350",
          type: "welding_machine",
          model: "XMT-350-MPa",
          serialNumber: "WM2024011"
        },
        project: {
          id: "proj-002",
          name: "Pipeline Section South",
          status: "active",
          startDate: "2024-02-01"
        },
        metadata: {
          manufacturer: "CRC-Evans",
          model: "WS-2000",
          serialNumber: "WS2024K11",
          installationDate: "2024-02-01",
          firmware: "v2.1.1"
        }
      },
      {
        id: "550e8400-e29b-41d4-a716-446655440011",
        name: "Coating Unit L12",
        type: "coating_device",
        status: "decommissioned",
        lastSeen: "2024-02-15T10:30:00Z",
        metadata: {
          manufacturer: "CRC-Evans",
          model: "CS-3000",
          serialNumber: "CS2024L12",
          installationDate: "2023-08-01",
          firmware: "v3.0.0"
        }
      },
      {
        id: "550e8400-e29b-41d4-a716-446655440012",
        name: "Welding Station M13",
        type: "welding_device",
        status: "connected",
        lastSeen: "2024-03-20T10:39:00Z",
        connectedEquipment: {
          id: "eq-013",
          name: "Lincoln Electric Power Wave",
          type: "welding_machine",
          model: "PW-S500",
          serialNumber: "WM2024013"
        },
        project: {
          id: "proj-003",
          name: "Pipeline Section East",
          status: "active",
          startDate: "2024-02-15"
        },
        metadata: {
          manufacturer: "CRC-Evans",
          model: "WS-2000",
          serialNumber: "WS2024M13",
          installationDate: "2024-02-15",
          firmware: "v2.1.1"
        }
      },
      {
        id: "550e8400-e29b-41d4-a716-446655440013",
        name: "Coating Unit N14",
        type: "coating_device",
        status: "commissioned",
        lastSeen: "2024-03-20T10:38:00Z",
        connectedEquipment: {
          id: "eq-014",
          name: "CRC-Evans Coating System",
          type: "coating_machine",
          model: "ACS-2000",
          serialNumber: "CM2024014"
        },
        project: {
          id: "proj-001",
          name: "Pipeline Section North",
          status: "active",
          startDate: "2024-01-15"
        },
        metadata: {
          manufacturer: "CRC-Evans",
          model: "CS-3000",
          serialNumber: "CS2024N14",
          installationDate: "2024-01-15",
          firmware: "v3.0.2"
        }
      },
      {
        id: "550e8400-e29b-41d4-a716-446655440014",
        name: "Welding Station O15",
        type: "welding_device",
        status: "communicating",
        lastSeen: "2024-03-20T10:37:00Z",
        connectedEquipment: {
          id: "eq-015",
          name: "Miller Dynasty",
          type: "welding_machine",
          model: "DY-280-DX",
          serialNumber: "WM2024015"
        },
        project: {
          id: "proj-002",
          name: "Pipeline Section South",
          status: "active",
          startDate: "2024-02-01"
        },
        metadata: {
          manufacturer: "CRC-Evans",
          model: "WS-2000",
          serialNumber: "WS2024O15",
          installationDate: "2024-02-01",
          firmware: "v2.1.1"
        }
      },
      {
        id: "550e8400-e29b-41d4-a716-446655440015",
        name: "Coating Unit P16",
        type: "coating_device",
        status: "disconnected",
        lastSeen: "2024-03-19T17:30:00Z",
        connectedEquipment: {
          id: "eq-016",
          name: "CRC-Evans Coating System",
          type: "coating_machine",
          model: "ACS-3000",
          serialNumber: "CM2024016"
        },
        metadata: {
          manufacturer: "CRC-Evans",
          model: "CS-3000",
          serialNumber: "CS2024P16",
          installationDate: "2024-02-20",
          firmware: "v3.0.2"
        }
      },
      {
        id: "550e8400-e29b-41d4-a716-446655440016",
        name: "Welding Station Q17",
        type: "welding_device",
        status: "connected",
        lastSeen: "2024-03-20T10:36:00Z",
        connectedEquipment: {
          id: "eq-017",
          name: "Miller XMT 350",
          type: "welding_machine",
          model: "XMT-350-MPa",
          serialNumber: "WM2024017"
        },
        project: {
          id: "proj-003",
          name: "Pipeline Section East",
          status: "active",
          startDate: "2024-02-15"
        },
        metadata: {
          manufacturer: "CRC-Evans",
          model: "WS-2000",
          serialNumber: "WS2024Q17",
          installationDate: "2024-02-15",
          firmware: "v2.1.1"
        }
      },
      {
        id: "550e8400-e29b-41d4-a716-446655440017",
        name: "Coating Unit R18",
        type: "coating_device",
        status: "decommissioned",
        lastSeen: "2024-02-10T10:30:00Z",
        metadata: {
          manufacturer: "CRC-Evans",
          model: "CS-3000",
          serialNumber: "CS2024R18",
          installationDate: "2023-07-15",
          firmware: "v3.0.0"
        }
      },
      {
        id: "550e8400-e29b-41d4-a716-446655440018",
        name: "Welding Station S19",
        type: "welding_device",
        status: "commissioned",
        lastSeen: "2024-03-20T10:35:00Z",
        connectedEquipment: {
          id: "eq-019",
          name: "Lincoln Electric Power Wave",
          type: "welding_machine",
          model: "PW-S500",
          serialNumber: "WM2024019"
        },
        project: {
          id: "proj-001",
          name: "Pipeline Section North",
          status: "active",
          startDate: "2024-01-15"
        },
        metadata: {
          manufacturer: "CRC-Evans",
          model: "WS-2000",
          serialNumber: "WS2024S19",
          installationDate: "2024-01-15",
          firmware: "v2.1.1"
        }
      },
      {
        id: "550e8400-e29b-41d4-a716-446655440019",
        name: "Coating Unit T20",
        type: "coating_device",
        status: "communicating",
        lastSeen: "2024-03-20T10:34:00Z",
        connectedEquipment: {
          id: "eq-020",
          name: "CRC-Evans Coating System",
          type: "coating_machine",
          model: "ACS-2000",
          serialNumber: "CM2024020"
        },
        project: {
          id: "proj-002",
          name: "Pipeline Section South",
          status: "active",
          startDate: "2024-02-01"
        },
        metadata: {
          manufacturer: "CRC-Evans",
          model: "CS-3000",
          serialNumber: "CS2024T20",
          installationDate: "2024-02-01",
          firmware: "v3.0.2"
        }
      },
      {
        id: "550e8400-e29b-41d4-a716-446655440020",
        name: "Welding Station U21",
        type: "welding_device",
        status: "connected",
        lastSeen: "2024-03-20T10:33:00Z",
        connectedEquipment: {
          id: "eq-021",
          name: "Miller Dynasty",
          type: "welding_machine",
          model: "DY-280-DX",
          serialNumber: "WM2024021"
        },
        project: {
          id: "proj-003",
          name: "Pipeline Section East",
          status: "active",
          startDate: "2024-02-15"
        },
        metadata: {
          manufacturer: "CRC-Evans",
          model: "WS-2000",
          serialNumber: "WS2024U21",
          installationDate: "2024-02-15",
          firmware: "v2.1.1"
        }
      },
      {
        id: "550e8400-e29b-41d4-a716-446655440021",
        name: "Coating Unit V22",
        type: "coating_device",
        status: "disconnected",
        lastSeen: "2024-03-19T18:30:00Z",
        connectedEquipment: {
          id: "eq-022",
          name: "CRC-Evans Coating System",
          type: "coating_machine",
          model: "ACS-3000",
          serialNumber: "CM2024022"
        },
        metadata: {
          manufacturer: "CRC-Evans",
          model: "CS-3000",
          serialNumber: "CS2024V22",
          installationDate: "2024-03-15",
          firmware: "v3.0.2"
        }
      },
      {
        id: "550e8400-e29b-41d4-a716-446655440022",
        name: "Welding Station W23",
        type: "welding_device",
        status: "commissioned",
        lastSeen: "2024-03-20T10:32:00Z",
        connectedEquipment: {
          id: "eq-023",
          name: "Miller XMT 350",
          type: "welding_machine",
          model: "XMT-350-MPa",
          serialNumber: "WM2024023"
        },
        project: {
          id: "proj-001",
          name: "Pipeline Section North",
          status: "active",
          startDate: "2024-01-15"
        },
        metadata: {
          manufacturer: "CRC-Evans",
          model: "WS-2000",
          serialNumber: "WS2024W23",
          installationDate: "2024-01-15",
          firmware: "v2.1.1"
        }
      },
      {
        id: "550e8400-e29b-41d4-a716-446655440023",
        name: "Coating Unit X24",
        type: "coating_device",
        status: "decommissioned",
        lastSeen: "2024-02-05T10:30:00Z",
        metadata: {
          manufacturer: "CRC-Evans",
          model: "CS-3000",
          serialNumber: "CS2024X24",
          installationDate: "2023-06-20",
          firmware: "v3.0.0"
        }
      },
      {
        id: "550e8400-e29b-41d4-a716-446655440024",
        name: "Welding Station Y25",
        type: "welding_device",
        status: "communicating",
        lastSeen: "2024-03-20T10:31:00Z",
        connectedEquipment: {
          id: "eq-025",
          name: "Lincoln Electric Power Wave",
          type: "welding_machine",
          model: "PW-S500",
          serialNumber: "WM2024025"
        },
        project: {
          id: "proj-002",
          name: "Pipeline Section South",
          status: "active",
          startDate: "2024-02-01"
        },
        metadata: {
          manufacturer: "CRC-Evans",
          model: "WS-2000",
          serialNumber: "WS2024Y25",
          installationDate: "2024-02-01",
          firmware: "v2.1.1"
        }
      }
];